<template>
	<div class="common_layout user_layout">
		<div
			class="flexRow"
			style="justify-content: space-between; flex-direction: column; min-height: calc(100vh - 32px)"
		>
			<div>
				<div class="paybox">
					<img src="../../assets/images/shopPay.png" style="width: 100%; min-height: 240px" />
					<div class="detail">
						<div class="topTitle" style="margin-top: 20px">
							支付成功！
							<!-- <p class="common_font" style="color: #FF4545; font-weight: normal;">预购商品预计11月初陆续发货</p> -->
						</div>

						<div class="flexRow" style="margin-top: 17px">
							<div class="left">支付金额：</div>
							<div class="right">
								¥
								<span style="font-size: 24px">{{ payCount }}</span>
							</div>
						</div>
						<div class="flexRow" style="padding: 0px 19px">
							<div class="yuandian"></div>
						</div>
						<div
							class="flexRow"
							style="margin-top: 17px; justify-content: flex-start; margin-left: 19px"
						>
							<div class="leftOrder">订单号：</div>
							<div class="rightOrder">{{ payOrder }}</div>
						</div>
						<div
							class="flexRow"
							style="margin-top: 30px; justify-content: flex-start; margin-left: 19px"
						>
							<div class="leftOrder">支付状态：</div>
							<div class="rightOrder">{{ payStatus }}</div>
						</div>
					</div>
				</div>
				<!-- <div class="detailbox">
					<div class="flexRow" style="justify-content: flex-start">
						<img style="width: 14px; height: 14px" src="../../assets/images/locate.png" />
						<div class="topTitle">收货信息</div>
					</div>
					<div class="yuandian"></div>
					<div class="flexRow detailrow" style="margin-top: 20px">
						<div class="detailrowleft">收货人姓名</div>
						<div class="detailrowRight">
							<input
								v-model="form.name"
								placeholder="请输入收货人姓名"
								:style="{ border: 'none' }"
							/>
						</div>
					</div>
					<div class="shixian"></div>
					<div class="flexRow detailrow" style="margin-top: 20px">
						<div class="detailrowleft">收货人手机号</div>
						<div class="detailrowRight">
							<div class="flexRow">
								<input
									v-model="form.phone"
									placeholder="请输入手机号码"
									:style="{ border: 'none' }"
									type="tel"
								/>
								<div style="opacity: 0.7; margin-left: 10px">|&nbsp;&nbsp;</div>
								<div>+</div>
								<input
									v-model="form.code"
									placeholder="区号"
									:style="{ border: 'none', width: '30px' }"
									type="tel"
								/>
							</div>

							<input
								v-model="form.phone"
								placeholder="请输入手机号码"
								:style="{ border: 'none' }"
								type="tel"
							/>
							<div class="flexRow" style="margin-left: 10px; flex-shrink: 0">
								<div style="opacity: 0.7; margin-right: 10px">|&nbsp;&nbsp;</div>
								<div style="position: absolute; width: 40px">
									<div class="addcode">+</div>
									<input
										v-model="form.code"
										placeholder="区号"
										:style="{ border: 'none', width: '32px', paddingLeft: '15px' }"
										type="tel"
									/>
								</div>
							</div>
						</div>
					</div>
					<div class="shixian"></div>
					<div class="flexRow detailrow" style="margin-top: 20px">
						<div class="detailrowleft">所在地区</div>
						<el-cascader
							@expand-change="changeExpend"
							:options="options"
							v-model="form.area"
							:clearable="false"
							placeholder="请选择地区"
						>
						</el-cascader>
						<div class="detailrowRight">
                            <img style="width: 14px; height: 14px;" src="../../assets/images/right_icon.png">
                        </div>
					</div>
					<div class="shixian"></div>
					<div class="flexRow detailrow" style="margin-top: 20px">
						<div class="detailrowleft">详细地址</div>
						<div class="detailrowRight">
							<input
								v-model="form.address"
								placeholder="请输入详细地址"
								:style="{ border: 'none' }"
							/>
						</div>
					</div>
				</div> -->
			</div>

			<!-- <a
				class="common_font"
				style="padding: 5px 0; margin-top: 10px; font-size: 12px"
				href="tel:400-920-3970"
				>客服电话:400-920-3970</a
			>
			<p class="common_font" style="padding: 0; margin: 0; font-size: 12px">
				客服邮箱:service@orota.cn
			</p>
			<p class="common_font" style="margin: 5px 0; font-size: 12px">(工作日10点至18点整)</p>

			<div class="bottomButton" @click="limitSubmit">提交</div> -->
		</div>
	</div>
</template>

<script setup>
import { reactive, ref, onMounted, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { addressDataFn } from "../../utils/secret";
import { post } from "../../utils/request";
import { Decrypt } from "../../utils/secret";
const { proxy } = getCurrentInstance();
const router = useRouter();
const form = reactive({
	name: "",
	phone: "",
	area: "",
	address: "",
	code: "",
});
const options = ref([]);
onMounted(() => {
	let data = addressDataFn().data;
	data.map((item, index) => {
		options.value.push({
			value: item.name,
			label: item.name,
			id: index,
			children: [],
		});

		item.city.map((itema, indexa) => {
			if (!itema.area || itema.area == "") {
				options.value[index].children.push({
					value: itema.name,
					label: itema.name,
					id: itema.id,
					code: itema.code,
				});
			} else {
				options.value[index].children.push({
					value: itema.name,
					label: itema.name,
					id: itema.id,
					children: [],
				});

				itema.area.map((itemb, indexb) => {
					options.value[index].children[indexa].children.push({
						value: itemb,
						label: itemb,
						id: itemb.id,
					});
				});
			}
		});
	});
	//先解码再解密
	if (router.currentRoute.value.query.orderData) {
		const encodedData = JSON.parse(
			Decrypt(decodeURIComponent(router.currentRoute.value.query.orderData))
		);
		payOrder.value = encodedData.orderId;
		payCount.value = encodedData.orderTotal;
	}
});
const payCount = ref("");
const payOrder = ref("");
const payStatus = ref("已付款");

const changeExpend = () => {
	console.log(111);
	setTimeout(() => {
		let a = document.getElementsByClassName("el-cascader-panel")[0];
		// a.scrollTo(1000,0)
		a.scrollLeft = 150;
	}, 50);
};

const limitSubmit = () => {
	proxy.$limit(submit, 3000);
};

const submit = () => {
	if (!form.name) {
		proxy.$toast("请输入收货人姓名");
		return;
	}
	if (!form.phone) {
		proxy.$toast("请输入手机号码");
		return;
	}
	if (!form.code) {
		proxy.$toast("请输入区号");
		return;
	}
	if (form.area.length == 0) {
		proxy.$toast("请选择所在地区");
		return;
	}
	if (form.address == 0) {
		proxy.$toast("请输入详细地址");
		return;
	}
	let param = {
		id: payOrder.value,
		receiver: form.name,
		code: form.code,
		mobile: form.phone,
		country: form.area[0] ? form.area[0] : "",
		city: form.area[1] ? form.area[1] : "",
		region: form.area[2] ? form.area[2] : "",
		address: form.address,
	};
	post(`/user/order/modify/address`, param, null)
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code == 1) {
				router.push(`/buysuccess?orderNo=${payOrder.value}`);
			} else {
				proxy.$toast(res.message);
			}
		})
		.catch((error) => {
			console.log(error);
		});
};
</script>

<style lang="less" scoped>
.user_layout {
	background-color: rgba(244, 243, 248, 1);
	min-height: 100vh;
	input {
		font-size: 14px;
	}
}
.flexRow {
	display: flex;
	align-items: center;
	justify-content: center;
	.left {
		font-size: 14px;
		font-weight: 400;
		color: #000000;
	}
	.right {
		font-size: 18px;
		font-weight: 600;
		color: #000000;
	}
	.leftOrder {
		font-size: 14px;
		font-weight: 400;
		color: #373737;
		width: 70px;
		opacity: 0.7;
	}
	.rightOrder {
		margin-left: 7px;
		font-size: 14px;
		font-weight: 400;
		color: #000000;
	}
}
.paybox {
	position: relative;
	.detail {
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		.topTitle {
			font-size: 18px;
			font-weight: 600;
			color: #775acc;
			margin-top: 35px;
			margin-left: 19px;
		}
	}
}
.detailbox {
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(126, 126, 153, 0.02);
	border-radius: 10px 10px 10px 10px;
	padding: 20px 17px;
	margin-top: 10px;
	.topTitle {
		font-size: 14px;
		font-weight: 500;
		color: #000000;
		margin-left: 7px;
	}
	.detailrow {
		justify-content: space-between;
		.detailrowleft {
			font-size: 13px;
			font-weight: 400;
			color: #000000;
			opacity: 0.5;
			width: 100px;
		}
		.detailrowRight {
			flex: 1;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			position: relative;
			.addcode {
				position: absolute;
			}
		}
		input {
			width: 98%;
			text-align: right;
		}
		input:focus {
			outline: none; /* 去除焦点时的边框（慎用） */
		}
	}
}
.yuandian {
	width: 100%;
	height: 100px;
	margin-top: 20px;
	border-top: 1px dashed rgba(126, 126, 153, 1);
	width: 100%;
	height: 0;
}
.shixian {
	opacity: 0.12;
	width: 100%;
	height: 100px;
	margin-top: 20px;
	border-top: 1px solid rgba(126, 126, 153, 1);
	width: 100%;
	height: 0;
}
.bottomButton {
	margin-bottom: 10px;
	width: 310px;
	height: 50px;
	background: #9570ff;
	border-radius: 100px 100px 100px 100px;
	opacity: 1;
	font-size: 16px;
	font-weight: 500;
	color: #ffffff;
	line-height: 50px;
	text-align: center;
}
</style>
